module.exports = __webpack_public_path__ + "static/img/Hospital's_Affiliated_Doctors.00df5f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Hospital's_Affiliated_Doctors.jpg
// module id = Uzll
// module chunks = 7